import axios from "axios";

import { getAuthorizationHeader } from "./auth_service";
import { convertFilterQueryParams } from "./strapi_utils";
const qs = require("qs");

export const createEvent = async (body) => {
  let res = await axios.post(
    process.env.REACT_APP_BACKEND_URL + `api/events`,
    { data: body },
    getAuthorizationHeader()
  );

  return res.data.data;
};

export const getEvent = async (filters = []) => {
  let teamIds = JSON.parse(localStorage.getItem("teamIDs")).map((el) => el.id);

  if (!teamIds.length) {
    return [];
  }

  const query = qs.stringify(
    {
      filters: {
        team: {
          id: {
            $in: teamIds,
          },
        },
        ...filters,
      },
    },
    {
      encodeValuesOnly: true, // prettify URL
    }
  );

  let res = await axios.get(
    process.env.REACT_APP_BACKEND_URL + `api/events?${query}&populate=*`,
    getAuthorizationHeader()
  );

  return res.data.data;
};

export const getEventById = async (id) => {
  let res = await axios.get(
    process.env.REACT_APP_BACKEND_URL + `api/events/${id}?populate=*`,
    getAuthorizationHeader()
  );

  return res.data.data;
};

export const deleteEvent = async (id) => {
  let res = await axios.delete(
    process.env.REACT_APP_BACKEND_URL + `api/events/${id}`,
    getAuthorizationHeader()
  );
  return res;
};
